/**
 * Cottagecore stickers — authored via the `/pack` toile process (plan
 * `thinking/plans/2026_08_31_toile_pack_wiring.md` Track B), wave `toile_stickers`. Narcis file-split
 * shape (Track A): one module per pack, `registry.ts` assembles them into `livePacks`.
 */
import {tagline, chips, type ToilePack} from './data'

export const cottagecoreStickersPack: ToilePack = {
    slug: 'cottagecore-stickers',
    category: 'sticker',
    name: 'Cottagecore stickers',
    tagline: tagline('pieces', 'themes', 'styles'),
    chips: chips('themes', 'styles'),
    ratio: {w: 1024, h: 1024},
    readings: [
        {key: 'basket', label: 'Wildflower basket', subject: 'a wicker basket of wildflowers'},
        {key: 'jam', label: 'Jam jar', subject: 'a jam jar with a cloth lid and a blank label'},
        {key: 'snail', label: 'Snail', subject: 'a snail with a tiny flower on its shell'},
    ],
    styles: [
        {key: 'retro', label: 'Retro', style: 'retro sticker illustration, 1970s shapes, halftone grain, slight misregistration', palette: 'Mustard, rust, teal and cream', framing: 'Each sticker isolated with a thick white die-cut border on a plain ground'},
        {key: 'bold', label: 'Bold cartoon', style: 'bold cartoon sticker, thick black outlines, bright flat fills, slight gloss', palette: 'Bright saturated primaries with black outlines', framing: 'Each sticker isolated with a thick white die-cut border on a plain ground'},
        {key: 'minimal', label: 'Minimal line', style: 'minimal single-line sticker, one clean continuous line, no fill', palette: 'Black line only, one accent colour', framing: 'Each sticker isolated with a thin white die-cut border on a plain ground'},
    ],
    directions: ['a mushroom instead', 'a whole sticker sheet', 'in autumn colors'],
    directionHint: 'try: a mushroom instead',
    seo: {
        title: 'Cottagecore Stickers: Basket, Jam Jar, Snail',
        metaDescription: 'Nine cottagecore stickers — a wildflower basket, a jam jar, a snail with a flower — in retro, bold cartoon, and minimal line styles.',
        h1: 'Cottagecore stickers: wildflower basket, jam jar, snail',
        tagline: 'Nine stickers, three cottagecore icons, three styles each.',
        intro: 'A wicker basket of wildflowers, a jam jar with a cloth lid and blank label, and a snail with a tiny flower on its shell — three cottagecore stickers, die-cut and ready to print. Each rendered retro, bold cartoon, and minimal single-line. Ask for a different jar contents, a garden-gate scene, or a picnic composition, and the same three styles carry it.',
        useCases: [
            'a water bottle or laptop lid',
            'a planner or journal page',
            'a kitchen jar or pantry label',
            'a nature-themed gift',
        ],
        faq: [
            {q: "What's in this pack?", a: 'Nine cottagecore stickers — a wildflower basket, a jam jar, and a snail — in retro, bold cartoon, and minimal line finishes.'},
            {q: 'Can I get a different scene, like a garden gate?', a: 'Yes — the direction field takes any variation, including different jar contents, a garden-gate scene, or a picnic composition.'},
            {q: 'What size should I print these at?', a: 'Each sticker is a square die-cut design, so it scales cleanly from a small vinyl sticker to a full A4 sheet.'},
            {q: 'Does the jam jar carry real text?', a: 'No — the label ships blank by design, so it prints clean or takes your own lettering afterward.'},
        ],
    },
}
